import {
  OPLOG_PULSE_CYCLES,
  OPLOG_PULSE_DURATION,
} from "features/TodoOploggSidebar/Oplogg/OploggElement/constants";
import styled, { css, keyframes } from "styled-components";

const oploggPulse = (fromAlarmColor: string, toAlarmColor: string) => keyframes`
    0% {
        background-color: ${fromAlarmColor};
    }
    50% {
        background-color: ${toAlarmColor};    
    }
    
    100% {
        background-color: ${fromAlarmColor};
    }
`;

export const LogItem = styled.li<{
  $readonly: boolean;
  $hover: string;
  $isSemantic: boolean;
}>`
  display: grid;
  grid-template-columns: 15px max-content 1fr;
  grid-template-rows: 1fr 24px 24px;
  gap: 6px;
  padding: 12px 12px 12px 6px;
  border-radius: 6px;
  max-width: 100%;
  box-sizing: border-box;

  outline: 1px solid transparent;

  transition: background-color 0.2s ease-in-out;

  ${({ $readonly, $hover, $isSemantic, theme }) =>
    !$readonly
      ? css`
          cursor: pointer;
          background-color: ${theme.colorBackgroundSecondary};
          transition: all 0.2s ease-in-out;

          &:hover {
            background-color: ${$hover};
            filter: ${$isSemantic ? null : theme.filterHover};
          }

          &[data-bookmarked="true"] {
            position: relative;
            background-color: transparent;
            animation: none;
            z-index: 9;

            // Before needed so that filter only hits background and not content
            &::before {
              content: "";
              position: absolute;
              inset: 0;
              border-radius: 5px;
              background-color: ${theme.colorBackgroundSecondary};
              filter: ${theme.filterSelected};
              z-index: -1;
            }
          }

          &[data-new="true"] {
            background-color: ${theme.colorAlarmFill};
            border: 1px solid ${theme.colorAlarmOutline};
            margin-bottom: 3px;

            animation: ${oploggPulse(
                theme.colorAlarmFill,
                theme.colorAlarmFillPulse,
              )}
              ${OPLOG_PULSE_DURATION}s ease-in-out ${OPLOG_PULSE_CYCLES}
              forwards;
          }

          &[data-new="true"]:hover {
            background-color: ${theme.colorAlarmFillPulse};
            animation: none;
          }

          &[data-new="true"][data-bookmarked="true"] {
            position: relative;
            background-color: transparent;
            animation: none;
            z-index: 9;

            // Before needed so that filter only hits background and not content
            &::before {
              content: "";
              position: absolute;
              inset: 0;
              border-radius: 5px;
              background-color: ${theme.colorAlarmFill};
              filter: ${theme.filterSelected};
              z-index: -1;
            }
          }

          &[data-almost-new="true"] {
            background-color: ${theme.colorSecondaryAlarmFill};
            border: 1px solid ${theme.colorSecondaryAlarmOutline};
            margin-bottom: 3px;
          }

          &[data-almost-new="true"]:hover {
            background-color: ${theme.colorSecondaryAlarmFillPulse};
          }

          &[data-almost-new="true"][data-bookmarked="true"] {
            position: relative;
            background-color: transparent;
            z-index: 9;

            // Before needed so that filter only hits background and not content
            &::before {
              content: "";
              position: absolute;
              inset: 0;
              border-radius: 5px;
              background-color: ${theme.colorSecondaryAlarmFill};
              filter: ${theme.filterSelected};
              z-index: -1;
            }
          }
        `
      : css`
          &[data-new="true"] {
            outline-color: ${theme.colorAlarm};
          }
        `}
`;

export const IndicatorWrapper = styled.div`
  grid-row: 1 / 4;
  margin-bottom: -13px;
  margin-top: -12px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const VerticalLineForHighlightedBox = styled.div`
  width: 1px;
  height: calc(100% - 3px);
  background-color: ${({ theme }) => theme.colorAlarm};
  margin-top: -2px;
  margin-left: 13px;
`;

export const VerticalLine = styled.div<{
  $color: string;
}>`
  width: 1px;
  height: calc(100% - 27px);
  background-color: ${({ $color }) => $color};
  margin: 0px auto;

  &:first-child {
    height: 17px;
  }
`;

export const HorizontalLineContainer = styled.div`
  width: 100%;
  height: 1px;
  margin: 3px 6px 3px 0;
  align-self: flex-end;
`;
